import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';

import {
    ICourseListItemFragment,
    ICoursesQueryVariables,
    CoursesDocument,
} from 'graphql/types';

export const useCourseList = (courseQueryVariables: ICoursesQueryVariables) => {
    const { loading, error, data } = useQuery(CoursesDocument, {
        variables: {
            q: courseQueryVariables.q,
            offset: courseQueryVariables.offset,
            ...courseQueryVariables,
        },
    });

    const coursesObject = data?.courses;
    const coursesCount = coursesObject?.count;
    const courses = useMemo(
        () =>
            (coursesObject?.edges
                .map((edge) => edge?.node || null)
                .filter(Boolean) as ICourseListItemFragment[]) || [],
        [coursesObject?.edges]
    );

    return {
        courses,
        coursesCount,
        loading,
        error,
    };
};
